import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const userFromCallback = location.state?.user;

  // User passed from AuthCallback or authenticated via provider
  if (user || userFromCallback) {
    return children;
  }

  // Still checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafafa]">
        <div className="animate-spin h-8 w-8 border-2 border-[#0a0a0a] border-t-transparent rounded-full"></div>
      </div>
    );
  }

  // Not authenticated
  return <Navigate to="/portal" replace />;
}
